import { Paper, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';

const WelcomeBanner = ({ subtitleText }) => {
  const user = useSelector((state) => state.user);
  return (
    <Paper
      style={{
        margin: '15px',
        marginBottom: '5px',
        padding: '20px',
        borderRadius: '10px',
        backgroundColor: '#5062F0',
        color: 'white',
        boxShadow: '2px 4px 6px rgba(0, 0, 0, 0.5)'
      }}
    >
      <Typography variant="h6" style={{ fontWeight: 400, color: '#FFFFFF' }}>
        Olá <strong>{user?.user ?? ''}</strong>, bem vindo de volta!
      </Typography>
      <Typography
        variant="subtitle1"
        style={{ marginTop: '8px', color: '#FFD166' }}
      >
        Acompanhe diariamente por aqui a operação da sua Rede
      </Typography>
    </Paper>
  );
};

export default WelcomeBanner;
